// extracted by mini-css-extract-plugin
export var errorIcon = "_oi-1";
export var nameLogo = "_oi-0";